import { toast, ToastOptions, ToastTransition, Zoom } from 'react-toastify';

type ToastDefaultConfig = Pick<ToastOptions, 'position' | 'hideProgressBar'
    | 'icon' | 'autoClose' | 'closeButton' | 'theme' | 'style'> & {
  transition: ToastTransition;
};

interface UseToastApi {
  showError: (message: string) => void;
  showSuccess: (message: string) => void;
  showWarning: (message: string) => void;
  showInfo: (message: string) => void;
  showPromise: (promise: Promise<any>, messages: {
    pending: string;
    success: string;
    error: string;
  }) => void;
}

const toastDefaultConfig: ToastDefaultConfig = {
  position: 'top-center',
  hideProgressBar: true,
  theme: 'colored',
  transition: Zoom,
  autoClose: 2000,
  icon: false,
  closeButton: true,
};

export const useToast = (): UseToastApi => {
  const showError = (message: string): void => {
    toast.error(message, { ...toastDefaultConfig });
  };

  const showSuccess = (message: string): void => {
    toast.success(message, { ...toastDefaultConfig });
  };

  const showWarning = (message: string): void => {
    toast.warn(message, { ...toastDefaultConfig });
  };

  const showInfo = (message: string): void => {
    toast.info(message, { ...toastDefaultConfig });
  };

  // New method to handle promise-based toasts
  const showPromise = (promise: Promise<any>, messages: {
    pending: string;
    success: string;
    error: string;
  }): void => {
    toast.promise(promise, {
      pending: {
        render: messages.pending,
        icon: true,
        closeButton: false,
        style: {
          color: '#2271b1',
          border: '1px solid #2271b1',
          background: '#fff',
          fontSize: '14px',
        },
      },
      success: {
        render: messages.success,
        icon: true,
        closeButton: false,
        style: {
          color: '#21af59',
          border: '1px solid #21af59',
          background: '#fff',
          fontSize: '14px',
        },
      },

      error: {
        render: messages.error,
        icon: true,
        closeButton: false,
        style: {
          color: '#af212d',
          border: '1px solid #af212d',
          background: '#fff',
          fontSize: '14px',
        },
      },

    }, { ...toastDefaultConfig });
  };

  return {
    showError,
    showSuccess,
    showWarning,
    showInfo,
    showPromise,
  };
};
